export const TooltipTextAddPieces = {
    pieces: 'Agregar piezas',
    packages: 'Agregar paquetes',
};

export const TooltipTextDeletePieces = {
    pieces: 'Quitar piezas',
    packages: 'Quitar paquetes',
};
